<template>
    <vs-popup classContent="popup-example" class="editService" title="ویرایش سرویس" :active.sync="showPopup">
        <div class="mb-base">
            <form class="px-4" @keydown.enter.prevent.self>
                <vs-row class="pb-5">
                    <vs-col vs-lg="4" vs-md="4" vs-sm="12">
                        <label class="vs-input--label">انتخاب کاربر</label>
                        <v-select :options="usersList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="user_id" :clearable="false" />
                    </vs-col>
                    <vs-col vs-lg="4" vs-md="4" vs-sm="12">
                        <label class="vs-input--label input-left">نوع دسته بندی</label>
                        <v-select :options="categoryList.items" class="input-left" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="category" :clearable="false" />
                    </vs-col>
                    <vs-col vs-lg="4" vs-md="4" vs-sm="12">
                        <label class="vs-input--label input-left">وضعیت</label>
                        <v-select :options="statusList" class="input-left" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="status" :clearable="false" />
                    </vs-col>
                </vs-row>
                <vs-textarea counter="350" class="service-textarea mt-4" v-model="details" />
                <vs-row class="mt-4" vs-w="12" vs-type="flex" vs-justify="center">
                    <vs-col class="sm:w-1/2 w-full">
                        
                    </vs-col>
                    <vs-col class="sm:w-1/2 w-full">
                        <vs-button class="mr-3 float-right" :disabled="counterDanger || !validateForm" @click="editOrderInfo()">ویرایش سرویس</vs-button>
                    </vs-col>
                </vs-row>
            </form>
        </div>
    </vs-popup>
</template>

<script>
import vSelect from 'vue-select'

export default {
    name: 'EditOrderService',

    props: {
        popupEditOrder: {
            type: Boolean,
            default: false,
        },
        orderId: Number
    },
    
    components: {
        vSelect,
    },
    
    data() {
		return{
            showPopup: false,
            details: '',
            category: '',
            user_id: '',
            status: '',
            statusList: ['سفارش جدید','در حال بررسی','در انتظار تایید مشتری','تایید مشتری','مرحله اندازه گیری','مرحله تولید','مرحله ارسال','مرحله نصب','تکمیل شده','کنسل شده'],
            counterDanger: false,
		}
    },
    
    computed: {
		categoryList() {
      		return {
                items: this.$store.state.orders.category.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name}`,
                        admin : `${robot.admin}`
                    }
                })
            }
        },
        usersList() {
            return {
                items: this.$store.state.users.users.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name} ${robot.last_name}`,
                    }
                })
            }
		},
        validateForm() {
            return this.user_id != '' && this.category != '' && this.status != '';
        },
    },

    watch: { 
      	popupEditOrder: function(newVal) {
            this.showPopup = newVal
            if(newVal == true){
                this.$vs.loading()
                this.getUser()
                this.$store.dispatch('getSystemInfo').catch(() => {
                    this.$vs.notify({
                        title: '',
                        text: 'خطا در اتصال به اینترنت',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                })
                this.$store.dispatch('getOrderInfo', this.orderId)
                .then((res) => {
                    let user = {
                        value: res.data.data.user_id.id,
                        label: res.data.data.user_id.name + ' ' + res.data.data.user_id.last_name
                    }
                    this.user_id = user
                    let cat = {
                        value: res.data.data.category.id,
                        label: res.data.data.category.name,
                        admin: res.data.data.category.admin
                    }
                    this.category = cat
                    this.details = res.data.data.desc
                    this.status = res.data.data.status
                    
                    this.$vs.loading.close()
                }).catch(() => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: '',
                        text: 'خطا در اتصال به اینترنت',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                })
            }
        },

        showPopup: function(newVal) {
            this.$emit('updatePopupEditOrder', newVal)
            this.details = ''
            this.category = ''
            this.user_id = ''
        },
    },

    created(){
    },
    
    methods: {
        getUser(){
			this.$store.dispatch('getAllUsers').catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'خطا در اتصال به اینترنت',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            })
		},

        editOrderInfo(){
            this.$vs.loading()
            this.$emit('updatePopupEditOrder', false)
            let payload = {
                orders: this.details,
                category: {
                    id: parseInt(this.category.value),
                    name: this.category.label,
                    admin: parseInt(this.category.admin),
                },
                user_id: this.user_id.value,
                type: 'service',
                message: this.details,
                status: this.status,
                id: this.orderId,
            }
            payload = { 
                data: JSON.stringify(payload)
            }
            this.details =''
            this.category = ''
            this.user_id = ''
			this.$store.dispatch('updateOrderInfo', payload)
			.then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
					title: '',
					text: 'سرویس با موفقیت ویرایش شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
            })
            .catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'اطلاعات ارسالی صحیح نمی باشد.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
				})
			})
        },
    }
}
</script>

<style scope>
.editService .vs-popup {
    width: 50% !important;
}

@media (max-width: 720px) {
    .editService .vs-popup {
        width: 90% !important;
    }
}
</style>